var CUSTOM_ORDER_PANEL_NAME = 'Customized selection';
var LEGACY_CUSTOM_ORDER_PANEL_NAME = 'Customized Gene Selection';
var INPUT_PLACEHOLDER = 'Enter a name for the custom order';
var NAME_ALREADY_EXISTS = 'A saved order with this name already exists. Please give the order a new name.';
var RNA_CUSTOM_ORDER_MESSAGE = 'Please note that RNA products cannot be saved as part of a custom order at this time.';

export { CUSTOM_ORDER_PANEL_NAME, INPUT_PLACEHOLDER, LEGACY_CUSTOM_ORDER_PANEL_NAME, NAME_ALREADY_EXISTS, RNA_CUSTOM_ORDER_MESSAGE };
//# sourceMappingURL=customOrder.esm.js.map
